import React, { Component } from "react";
import styled from "styled-components";
import ReactDOM from 'react-dom'

const Container = styled.section`
    margin: 0;
    padding-bottom: 0;

    // Only mobile
    @media (max-width: 768px) {
        margin: 0 15px;
    }

    &.collapsed {
        padding-bottom: 6px;
    }

    > h4 {
        cursor: pointer;
        font-family: Lato-Light;
        font-size: 18px;
        font-weight: normal;

        color: #4D4D4D;
        text-align: left;
        line-height: 22px;
        padding-bottom: 6px;
        margin-bottom: 15px;
        margin-top: 0;
        border-bottom: 1px solid #CCCCCC;

        > span {
            font-family: Lato-Regular;
            font-size: 14px;
            color: #1d71bb;
            text-align: right;
            line-height: 28px;
            text-decoration: none;
            float: right;
            vertical-align: middle;
        }

        > span:before {
            content: "${props => props.showLinkLabel != null ? props.showLinkLabel : ''}";
    
            // Mobile version.
            @media (max-width: 768px) {
                content: "${props => props.showLinkMobileLabel != null ? props.showLinkMobileLabel : ''}";
            }
        }
    
        &[aria-expanded=true] {
            > span:before {
                content: "${props => props.hideLinkLabel != null ? props.hideLinkLabel : ''}";
    
                // Mobile version.
                @media (max-width: 768px) {
                    content: "${props => props.hideLinkMobileLabel != null ? props.hideLinkMobileLabel : ''}";
                }
            }
        }
    }

    > ul {
        display: block;
        padding: 0;
        margin: 0;

        &.collapsed {
            display: none;
        }

        > li {
            display: inline-block;
            margin-left: 30px;
            margin-bottom: 30px;

            // Mobile version.
            @media (max-width: 768px) {
                margin-left: 0;
                margin-bottom: 15px;
                display: block;
            }
        }

        // Only desktop
        @media (min-width: 768px) {
            > li:nth-child(3n+1) {
                margin-left: 0;
            }  
        }
    }
`

class TilesArea extends Component {

    componentDidMount() {
        const domNode = ReactDOM.findDOMNode(this);
        var areaTtle = domNode.querySelectorAll('h4[aria-expanded][aria-controls]');
        var be = new window.ButtonExpand(areaTtle[0]);
        be.init();
    }

  render() {
    return (
      <Container 
            showLinkLabel={this.props.showLinkLabel}
            hideLinkLabel={this.props.hideLinkLabel}
            showLinkMobileLabel={this.props.showLinkMobileLabel}
            hideLinkMobileLabel={this.props.hideLinkMobileLabel}
            aria-label={this.props.title} className={this.props.className}>
            <h4 tabIndex={0} role="button" aria-expanded="true" aria-controls={this.props.areaId}>
                {this.props.title}
                <span className="hide-show-vest-area"/>
            </h4>
            <ul id={this.props.areaId} className='vest-area'>
                {this.props.children}
            </ul>
      </Container>
    );
  }
}

export default TilesArea;
